(function ($) {
  $(document).ready(function () {
    if ($(".exercise-link").length >= 1) {
      $("img").lazyload({ threshold: 4000 });
    }
  });
})(jQuery);
